<template>
  <div class="build-details">
    <ba-header activeModule="builds" v-if="isUserAuthorized"></ba-header>
    <div v-loading="loading" class="build-details__root main-content">
      <div class="u-pt4"></div>
      <div class="u-pt4"></div>
      <div v-if="!isUserAuthorized">
        <el-button type="success" @click="$router.push({ name: 'login'})" >Login</el-button>
      </div>
      <h2 v-if="!isUserAuthorized" class="u-text--center">{{ build.company }}</h2>
      <h2 class="u-text--center">Build {{ humanBuildId }} Details</h2>
      <div class="controls-container u-text--center"  v-if="isUserAuthorized">
        <el-button  icon="el-icon-refresh" @click="invalidateBuildStatus()">Invalidate Status</el-button>
      </div>
      <div class="u-text--center u-mt3">
          <ba-status-label v-loading="loadingStatus" element-loading-background="rgba(0, 0, 0, 0.1)"  v-if="build" :build="build"></ba-status-label>
      </div>


      <div v-if="loading">Loading...</div>
      <div v-if="!loading && build && isUserAuthorized" >
        <div class="apk-download u-text--center u-mt4">
          <a :href="ApkLink">Download Android APK</a>
        </div>
        <div class="apk-download u-text--center u-mt4">
          <a :href="AabLink">Download Android AAB</a>
        </div>

        <div class="google-play-promote u-text--center u-mt4">
          <div class="u-mt4">
            <el-button v-loading="bitriseSubmissionInProgress" title="Build and deploy iOS app on Bitrise. After build is completed, it will be published to TestFlight" @click="sendBuildToBitrise('ios')" type="info">
              <icon name="apple"></icon>
              <span class="u-ml1">Build on Bitrise</span>
            </el-button>
            <el-button v-loading="bitriseSubmissionInProgress" @click="renewCertificatesViaBitrise" type="info">
              <icon name="apple"></icon>
              <span class="u-ml1">Renew Certificates via Bitrise</span>
            </el-button>
          </div>
        </div>
        <div class="u-text--center u-mt4">
          <el-button @click="downloadBuildScreenshots">
            Download Screenshots
          </el-button>
        </div>
        <div class="u-text--right u-mt4">
          <el-checkbox  v-model="showBuildTechnicalDetails">Show Build Technical Details</el-checkbox>
        </div>
        <el-collapse-transition>
          <div v-show="showBuildTechnicalDetails">

            <pre class="build__pre u-px4">
            <div>Build status : {{build.status}}</div>
            <div>aws_build_id : {{build.aws_build_id}}</div>
            <div>internal_id : {{build.internal_id}}</div>
            <div>queued_at: {{build.queued_at | moment('YYYY-MM-DD HH:mm')}}</div>
            <div>queued_at (UTC): {{build.queued_at}} (UTC)</div>
            <div>commit_id: {{build.commit_id ? build.commit_id : '[master]'}}</div>
            <div>queued_by: {{build.queued_by}}</div>

            </pre>
          </div>

        </el-collapse-transition>

      </div>
      <div class="row" v-if="!loading && build">
        <div class="col-12">
        </div>
        <div class="col-12">
          <h3 class="u-text--center u-mt4">Build Preview</h3>

          <ba-build-preview ref="buildPreviewElement" :url="buildPreviewLink">
          </ba-build-preview>
          <h4 class="u-text--center u-text--light u-text--sm u-mt4 u-pb5" title="Build comment">{{build.comment}}</h4>

        </div>
        <div class="u-ml5">
          <ba-build-log :mode="'mobile'" :build-id="buildId"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'

import config from '@/config'

import BuildPreview from './build-preview.component.vue'
import ElTag from 'element-ui/packages/tag/src/tag'
import { mapState } from 'vuex'
import BaBuildLog from './build-log.component'

export default {
  components: {
    BaBuildLog,
    ElTag,
    'ba-build-preview': BuildPreview,
  },
  data () {
    let buildId = this.$route.params.buildId
    let companyId = this.$route.params.companyId
    return {
      initBuildPreviewLink: null,
      loading: true,
      loadingStatus: false,
      buildId,
      showBuildTechnicalDetails: false,
      build: {},
      loadBuildTimerRef: null,
      companyId,
      bitriseSubmissionInProgress: false,
    }
  },

  computed: {
    ...mapState('shared', ['user']),
    ...mapState('login', ['token']),
    isUserAuthorized () {
      return (this.user !== null && this.token !== null)
    },
    buildPreviewLink () {
      let updatedUrl = this.replacePotentialHttpProtocol(this.build.aws_build_preview)
      return updatedUrl
    },
    ApkLink () {
      return this.build.android_release_apk
    },
    AabLink () {
      return this.build.android_release_bundle
    },
    humanBuildId () {
      return this.build ? this.build.version + '.' + this.build.build_number : 'UNDEFINED'
    }
  },
  methods: {
    async downloadBuildScreenshots () {
      let url = config.url +'/build/' + this.buildId + '/' + 'screenshots' + `?token=${localStorage.carrierToken}`
      window.open(url, '_blank')
    },
    async sendBuildToBitrise (platform) {
      this.bitriseSubmissionInProgress = true
      try {
        await axios.post(config.url +'/build/' + this.buildId + '/' + 'promote/via-bitrise', {platform: platform})
        this.$notify({
          message: 'Build has been submitted to the Bitrise queue',
          type: 'success'
        })
      } catch (e) {
        console.log(e)
        this.$notify({
          message: 'Error occurred while trying to submit build to the Bitrise.',
          type: 'error'
        })
      } finally {
        this.bitriseSubmissionInProgress = false
      }
    },
    async renewCertificatesViaBitrise () {
      this.bitriseSubmissionInProgress = true
      try {
        await axios.post(config.url +'/build/' + this.buildId + '/' + 'ios/renew-certificates', {})
        this.$notify({
          message: 'Certificates are queued for renewal on Bitrise. Manual steps are required for process to complete.',
          type: 'success'
        })
      } catch (e) {
        console.log(e)
        this.$notify({
          message: 'Error occurred while trying to push task to the Bitrise.',
          type: 'error'
        })
      } finally {
        this.bitriseSubmissionInProgress = false
      }
    },
    replacePotentialHttpProtocol (url) {
      if (url.startsWith('http://')) {
        if (document.location.protocol.startsWith('https:')) {
          return url.replace('http://', 'https://')
        }
      }
      return url
    },
    invalidateBuildStatus () {
      this.$refs.buildPreviewElement.invalidateIframe()
      this.loading = true
      axios.patch(config.url + '/build/' + this.buildId + '/')
        .then(response => {
          this.loading = false
          this.build = response.data
        })
    },
    loadBuild () {
      if (this.build.status && ['queued', 'IN_PROGRESS'].indexOf(this.build.status) === -1) {
        this.loading = false
        return
      }
      if (!this.loading) {
        this.loadingStatus = true
      }
      axios.get(config.url + '/build/' + this.buildId + '/')
        .then(response => {
          if (!this.loading) {
            this.loadingStatus = false
          }
          this.loading = false
          this.build = response.data
          if (['queued', 'IN_PROGRESS'].indexOf(this.build.status) !== -1) {
            this.loadingStatus = true
            this.initBuildStatus = this.build.status
            this.loadBuildTimerRef = setTimeout(this.loadBuild, 15000)
          } else {
            this.loadingStatus = false
            if (this.initBuildStatus !== null) {
              this.$refs.buildPreviewElement.invalidateIframe()
            }
          }
        })
    },
  },
  beforeMount () {
    this.loading = true
    this.initBuildStatus = null
    this.loadBuild()
  },
  beforeDestroy () {
    clearTimeout(this.loadBuildTimerRef)
  }
}
</script>
<style>

  .build__pre {
    background-color: #eeeeee;

  }

</style>
